import DatePicker from 'react-datepicker';
import * as React from 'react';
import { ModalHeader, Modal, ModalBody, ModalFooter, Button, Container, Form, Row, Col, FormGroup, Input, Label, UncontrolledTooltip } from 'reactstrap';
import { DataTableButton } from '../DataTable';

interface ICreateApiKeyModalProps {
    isOpen: boolean;
    submitDisabled: boolean;
    apikey: string | undefined;
    onSubmit: (name: string | null, date: Date | null) => void;
    onClose: () => void;
}

type ApiKeysPageState = {
    name: string | null;
    date: Date | null;
    viewKey: boolean;
}

export default class CreateApiKeyModal extends React.Component<ICreateApiKeyModalProps, ApiKeysPageState, {}>{

    constructor(props: any) {
        super(props)
        this.state = {
            name: null,
            date: null,
            viewKey: false,
        }
    }

    componentDidUpdate(prevProps: ICreateApiKeyModalProps) {
        if (!this.props.submitDisabled && prevProps.submitDisabled) {
            this.setState({ name: null, date: null, viewKey: false, })
        }
    }

    close = () => {
        this.props.onClose();
        this.setState({ name: null, date: null, viewKey: false, })
    }

    public render() {
        return (
            <Modal isOpen={this.props.isOpen}>
                <ModalHeader>Create API Key</ModalHeader>
                <ModalBody>
                    <React.Fragment>
                        <Container>
                            <Form>
                                {this.props.apikey &&
                                    <>
                                    <Row>
                                        <Label for="apikey">API Key:</Label>
                                        <DataTableButton icon='visibility' id='apikeyview' title='View API Key'
                                            action={() => this.setState({ viewKey: !this.state.viewKey })} />
                                        <DataTableButton icon='content_copy' id='apikeycopy' title='Copy API Key'
                                            action={() => { navigator.clipboard.writeText(this.props.apikey!) }} />
                                            <Input
                                                type={this.state.viewKey ? "text" : "password"}
                                                name="apikey"
                                                id="apikey"
                                                value={this.props.apikey}
                                        />
                                        <UncontrolledTooltip
                                            placement="right"
                                            target="apikeycopy"
                                            trigger="click"
                                            text="Copied"
                                        >Copied</UncontrolledTooltip>
                                    </Row>
                                    <br/>
                                    </>
                                }
                                <Row>
                                    <Col md={{ size: 6 }}>
                                        <FormGroup>
                                            <Label for="name">API Key Name</Label>
                                            <Input
                                                type="text"
                                                name="name"
                                                id="apiName"
                                                value={this.state.name || ""}
                                                onChange={(e) => { this.setState({ name: e.target.value }) }}
                                                disabled={this.props.apikey !== undefined}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col md={{ size: 6 }}>
                                        <FormGroup>
                                            <Label for="lifetime">Expiration Date</Label>
                                            <DatePicker
                                                name="lifetime"
                                                id="lifetime"
                                                className='form-control'
                                                peekNextMonth
                                                showMonthDropdown
                                                showYearDropdown
                                                dropdownMode="select"
                                                selected={this.state.date}
                                                onChange={(e) => { this.setState({ date: e! }) }}
                                                disabled={this.props.apikey !== undefined}
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>
                            </Form>
                        </Container>
                    </React.Fragment>
                </ModalBody>
                <ModalFooter>
                    <Button color={this.props.submitDisabled ? 'secondary' : 'primary'} disabled={this.props.submitDisabled} onClick={() => this.props.onSubmit(this.state.name, this.state.date)}>Submit</Button>
                    <Button onClick={this.close}>Close</Button>
                </ModalFooter>
            </Modal>
        )
    }
}